import React from "react";

import { Show, SimpleShowLayout, TextField, DateField, SelectField } from "react-admin";
import { RichTextField } from "react-admin";
import { auctionType, dateOptions } from "../../../utils/options";
import { languageChoices } from "../../../utils/options";

const ShowAuctions = () => {
  return (
    <Show title="Детайли за Търг - наеми/продажби">
      <SimpleShowLayout>
        <SelectField
          label="Език"
          source="language"
          choices={languageChoices}
        />
        <TextField
          label="Заглавие"
          source="title"
        />
        <RichTextField
          label="Съобщение"
          source="content"
        />
        <SelectField
          label="Вид"
          source="auction_type"
          choices={auctionType}
        />
        <DateField
          label="Дата от"
          source="starting_on"
          locales={"bg"}
          options={dateOptions}
        />
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowAuctions;
